import React from 'react';
import TestAccordion from '../TestAccordion';
import { Box, Divider } from '@mui/material';
import { useSparkBuilderStore } from 'stores';
import { useDialog } from 'hooks/common/useDialog';
import { useGetPromptFunctionsByID } from 'hooks/SparkBuilder/promptFunctions';
import { parseJSONCleaned } from 'utilities/index';
import type { StepTest } from 'types/SparkStep';
import type { PromptFunctions } from 'types/PromptFunctions';
import PromptAccordion from '../PromptAccordion';

type PromptFunctionsFormProps = {
  promptFunctionID: PromptFunctions['id'];
  handleContinue: () => void;
};

function PromptFunctionsForm({
  promptFunctionID,
  handleContinue,
}: PromptFunctionsFormProps) {
  const [showSecondStep, setShowSecondStep] = React.useState(false);

  const selectedStep = useSparkBuilderStore(
    (store) => store.builderSideBar.selectedStep
  );
  const sparkStep = useSparkBuilderStore((store) =>
    store.sparkStepsActions.getSparkStep(selectedStep?.id || '')
  );

  const { data: promptFunctions } = useGetPromptFunctionsByID(promptFunctionID);
  const { outputBoardNodeTypeID } = promptFunctions?.data?.attributes || {};

  const sparkTestResults = parseJSONCleaned<StepTest>(
    sparkStep?.attributes.testResults || ''
  );
  const isOutputAvailable = !!sparkTestResults?.SparkTask.Output;

  const testDialogConfig = useDialog(isOutputAvailable);

  const promptDialogConfig = useDialog(!isOutputAvailable);
  const localTestDialogConfig = useDialog(isOutputAvailable);

  // Use provided test dialog config or local one
  const effectiveTestDialogConfig = testDialogConfig || localTestDialogConfig;

  // Handlers
  const handlePromptOpen = () => {
    promptDialogConfig.openDialog();
    effectiveTestDialogConfig.closeDialog();
  };

  const handleTestOpen = () => {
    promptDialogConfig.closeDialog();
    testDialogConfig.openDialog();
  };

  const handleAfterSubmit = () => {
    handleTestOpen();
  };

  const hasTestIssues = sparkStep?.meta.diagnostics.hasTestIssues || false;

  return (
    <Box width='100%' key={selectedStep?.id}>
      <PromptAccordion
        promptFunctionID={promptFunctionID}
        dialogConfig={{ ...promptDialogConfig, openDialog: handlePromptOpen }}
        onShowStepChange={setShowSecondStep}
        onAfterSubmit={handleAfterSubmit}
      />
      <Box width='100%'>
        <Divider />
      </Box>
      {showSecondStep && (
        <TestAccordion
          sparkTestResults={sparkTestResults}
          dialogConfig={{ ...testDialogConfig, openDialog: handleTestOpen }}
          hasTestIssues={hasTestIssues}
          handleContinue={handleContinue}
          outputTypeID={outputBoardNodeTypeID}
        />
      )}
    </Box>
  );
}
export default PromptFunctionsForm;
